import { render, staticRenderFns } from "./FundingProfile.vue?vue&type=template&id=0afe4332"
import script from "./FundingProfile.vue?vue&type=script&lang=js"
export * from "./FundingProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports